export const UNTENANTED_PRODUCTS = ['TRELLO', 'BITBUCKET'];
